










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Indicator extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isPositive!: boolean;

  @Prop({ type: String, default: '' })
  readonly tooltipText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/indicator/Indicator.vue